type Maybe<T> = {result?: T; error?: unknown};

/**
 * Takes a promise and returns a Maybe type of the result or an error. This can be used to
 * avoid try/catch blocks which can be difficult to read and maintain.
 */
async function maybe<TResult>(promise: Promise<TResult>): Promise<Maybe<TResult>> {
	return promise
		.then(result => ({result}))
		.catch((error: unknown) => ({error})) as unknown as Maybe<TResult>;
}

/**
 * Wraps a fetch request and returns a Maybe type of the resulting JSON or an error. This
 * can be used to avoid try/catch blocks which can be difficult to read and maintain.
 */
async function maybeFetch<TResult>(input: RequestInfo | URL, init?: RequestInit | undefined): Promise<Maybe<TResult>> {
	return fetch(input, init)
		.then(async response => response.json() as Promise<TResult>)
		.then(result => ({result}))
		.catch((error: unknown) => ({error})) as unknown as Maybe<TResult>;
}

export {
	type Maybe,

	maybe,
	maybeFetch,
};
